import { latestLocation } from '@/infrastructure/adapters/constants'
import { RouteLoginRedirect } from '@/modules/login-redirect-module/routes'
import { NavigationGuard, NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

export const LatestLocationHandler: NavigationGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (to.path !== RouteLoginRedirect.path) {
    localStorage.setItem(latestLocation, to.path)
  }
  next()
}
